import { Box, type BoxProps } from '@lingoda/ui';

type TileBodyProps = BoxProps;

export const TileBody = (props: TileBodyProps) => {
    return <Box padding={3} {...props} />;
};
